// 首页
const home = {
    // baidu: 'https://baidu.com'
    //首页中间
    vedio: 'https://youtu.be/Q1m9BXr3aJ4',
    vedio_embed: 'https://www.youtube.com/embed/Q1m9BXr3aJ4',
    //whitepaper: 'https://mvsdna.com/wp-content/uploads/2020/03/MVS_Dualchain_White_Paper-v.1.00.pdf',
    whitepaper: '/MVS_Dualchain_White_Paper-v.1.00.pdf',

    social_twitter: 'https://twitter.com/mvsdna',
    social_telegram: 'https://t.me/mvsdna',
    social_medium: 'https://medium.com/metaverse-blockchain',
    social_facebook: 'https://www.facebook.com/MVSDNA',
    social_youtube: 'https://www.youtube.com/channel/UCdDGnCLtG2Fb6McCaDcAiBw'
}

const what = {
    // dna_wallet: 'https://explorercc.mvsdnadev.com/',
    // dna_explorer: 'https://explorercc.mvsdnadev.com/',
    // dna_bounty: 'https://bountycc.mvsdnadev.com/',
    dna_wallet: 'https://explorer.mvsdna.com/#/asset/receive',
    dna_explorer: 'https://explorer.mvsdna.com/',
    dna_bounty: 'https://bounty.mvsdna.dev/',

}

const dev = {
    get_start: '',
    dev_docs: '',

    free_dna: 'https://freedna.mvs.org',
    github: '',

    test_net: ''
}

const community = {
    ambassador: '',
    get_start: 'https://docs.google.com/forms/d/e/1FAIpQLSfLfnzNPnpcy9Eb5MB5HOPORpebELEZX55NADE-8h4d-ErQ3Q/viewform',
}


//latest_blogs根据图片编号
const community_latest_blogs = {
    1: 'https://medium.com/metaverse-blockchain/metaverse-dualchain-network-architecture-dna-continues-global-expansion-and-announces-a-819bb60dcacf',
    2: 'https://medium.com/metaverse-blockchain/highlights-from-hotbit-interview-with-metaverse-dna-founder-eric-gu-5abadd10dd68',
    3: 'https://medium.com/metaverse-blockchain/highlights-from-finwise-interview-with-alex-lightman-metaverse-dna-global-strategy-advisor-and-50efc6cc35bb',
    4: 'https://medium.com/metaverse-blockchain/metaverse-dna-concludes-a-successful-bounty-for-blockchain-community-engagement-with-12-000-in-2ee6e705607a',
    5: 'https://medium.com/@mvsdna/metaverse-dna-vietnam-introduces-the-dna-hangout-a-rooftop-event-space-in-the-heart-of-ho-chi-4e7978693bca',
    6: 'https://medium.com/metaverse-blockchain/introducing-tutorials-by-metaverse-ab2e0e5d34b2',
    7: 'https://medium.com/metaverse-blockchain/metaverse-dna-partners-with-tezos-southeast-asia-and-tomochain-to-present-tek2students-an-11f850bcbe89',
    8: 'https://medium.com/metaverse-blockchain/announcing-metaverse-dna-bounty-2-91816032d424',
    9: 'https://medium.com/metaverse-blockchain/dualchain-network-architecture-the-scalability-solution-by-metaverse-1890408a2b71',
    10: 'https://medium.com/metaverse-blockchain/metaverse-dna-technology-stack-delivering-performance-interoperability-78e2d627e97d',
    11: 'https://medium.com/metaverse-blockchain/pow-pos-dpos-navigating-the-world-of-consensus-mechanisms-dfa0e588f392',
    12: 'https://medium.com/metaverse-blockchain/interoperability-is-essential-for-dapps-to-thrive-fc3860d76a17',
}

//media_partner排列，先从上到下第1列，再右边第2列
const community_media_partner = {
    //35
    yahoo: 'https://www.yahoo.com/news/metaverse-tackles-scalability-interoperability-launch-045800107.html',
    //36
    blockmanity: 'https://blockmanity.com/press-release-2/metaverse-foundation-launches-new-dna-token-on-rightbtc/',
    //37
    hackernoon: 'https://hackernoon.com/powering-the-future-decentralized-oracles-and-metaverse-dna-4hg93yz8',
    //38
    coinidol: 'https://coinidol.com/metaverse-dna-blockchain-network-governance/',
    //39
    bitcoin: 'https://news.bitcoin.com/metaverse-dualchain-network-architecture-dna-continues-global-expansion-and-announces-a-successful-first-quarter-in-2020/',
    //40
    coinspeaker: 'https://www.coinspeaker.com/metaverse-foundation-launches-new-dna-token-on-rightbtc/',
    //41
    bitcoinprbuzz: 'https://bitcoinprbuzz.com/metaverse-dna-tezos-tomochain/',
    //42
    businessinsider: 'https://markets.businessinsider.com/news/stocks/metaverse-foundation-launches-new-dna-token-on-rightbtc-1028517902#',
    //43
    thebitcoinnews: 'https://thebitcoinnews.com/metaverse-dna-partners-with-tezos-and-tomochain-to-present-tek2students-an-educational-workshop-series-for-it-students-in-vietnam/',
    //44
    themerkle: 'https://themerkle.com/metaverse-dna-partners-with-tezos-and-tomochain-to-present-tek2students-an-educational-workshop-series-for-it-students-in-vietnam/?fbclid=IwAR0VucHKD9nkBI1UcEn8hVx7hBqp5wxuMjNmAwteJHBaB4kMKs4haSXXJGU',
}

//exchange排列，先从上到下第1列，再右边第2列
const community_exchanges = {
    //45
    zb: 'https://www.zb.com/en/kline/dna_usdt',
    //46
    bittrex: 'https://global.bittrex.com/Market/Index?MarketName=BTC-DNA',
    //47
    bitz: 'https://www.bitz.so/exchange/dna_usdt',
    //48
    bibox: 'https://www.bibox.com/v2/exchange?pair=DNA_USDT',
    //49
    okex: 'https://www.okex.com/spot/trade/dna-usdt',
    //50
    mxc: 'https://www.mxc.com/trade/easy#DNA_USDT',
    //51
    hotbit: 'https://www.hotbit.io/exchange?symbol=DNA_USDT',
    //52
    coinsuper: 'https://www.coinsuper.com/trade?symbol=DNA%2FUSDT',
    //53
    rightbtc: 'https://rightbtc.com/trading/spot/DNAUSDT',
    //54
    biki: 'https://www.biki.cc/en_US/trade/DNA_USDT',
    //55
    bw: 'https://www.bw.com/newTrade/spotTradding/dna_usdt',
}

const dbi = {
    get_start: 'https://forms.gle/smJECiu9dvjZosQS7',
    sign: 'https://forms.gle/17oWng9DnjWGTayv9',
    open_technology_standards: '',
    open_technology_standards_form: '',
    funding_grants: ''
}


export {
    home,
    what,
    dev,
    community,
    community_latest_blogs,
    community_media_partner,
    community_exchanges,
    dbi
}



// WEBPACK FOOTER //
// ./src/common/link.js